export default __webpack_public_path__ + "static/media/jokerPokerTablePrt.8818b9bf.webp";